<template>
  <div class="main">
    <div>
      <h1>用户信息更新</h1>
      <el-form ref="ruleForm" status-icon :model="ruleForm" label-width="80px" label-position="top">

        <el-form-item label="用户名" prop="username">
          <el-input v-model="ruleForm.username" placeholder :disabled="true"></el-input>
        </el-form-item>

        <!--                <el-form-item label="新密码" prop="pass">-->
        <!--                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="密码至少6位数"></el-input>-->
        <!--                </el-form-item>-->
        <!--                <el-form-item label="确认新密码" prop="checkPass">-->
        <!--                    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="密码至少6位数"></el-input>-->
        <!--                </el-form-item>-->

        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请确保手机号码正确，系统暂时不支持发送验证码验证"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email" placeholder="请确保邮箱正确，系统暂时不支持发送验证码验证"></el-input>
        </el-form-item>

        <el-form-item label="wpsID" prop="wpsID">
          <div>
            <el-input v-model="ruleForm.wpsID" placeholder="wps中唯一的用户ID"></el-input>
            <a href="https://www.kdocs.cn/l/cueLYPYVmtxP" target="_Blank">获取wpsID</a>

          </div>

        </el-form-item>

        <el-form-item class="register-btn">
          <el-button style="width: 190px" type="primary" size="medium" @click="update">更新</el-button>
          <el-button style="width: 190px" type="info" size="medium" @click="resetForm()">重置</el-button>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {Apis} from "../api";
import {Utils} from "@/utils/utils";

export default {
  data() {
    // const validatePass = (rule, value, callback) => {
    //     if (value === '') {
    //         callback(new Error('请输入密码'));
    //     }
    //     else if(value.length<6){
    //         callback(new Error('密码至少6位数'));
    //     }else {
    //         if (this.ruleForm.checkPass !== '') {
    //             this.$refs.ruleForm.validateField('username');
    //         }
    //         callback();
    //     }
    // };
    // const validatePass2 = (rule, value, callback) => {
    //     if (value === '') {
    //         callback(new Error('请再次输入密码'));
    //     } else if (value !== this.ruleForm.pass) {
    //         callback(new Error('两次输入密码不一致!'));
    //     } else {
    //         callback();
    //     }
    // };

    return {
      ruleForm: {
        id: -1,
        username: '',
        pass: '',
        checkPass: '',
        phone: '',
        email: '',
        wpsID: "",
      },
      // rules: {
      //     pass: [
      //         { validator: validatePass, trigger: 'blur' }
      //     ],
      //     checkPass: [
      //         { validator: validatePass2, trigger: 'blur' }
      //     ]
      // }
    };
  },
  methods: {
    async update() {
      if (this.ruleForm.username === "" || this.ruleForm.email == "" || this.ruleForm.wpsID == "") {
        this.$message.error("用户名，手机号码，邮箱，wpsID，都不能为空");
        return
      }
      const response = await Apis.User.update(this.ruleForm.id, this.ruleForm.phone, this.ruleForm.email, this.ruleForm.wpsID);

      if (response != null && response.errno === 0) {
        this.$message.success("用户信息更新成功!")
        // await this.$router.push({name: "Index"})
        await this.$router.go(0) //不再跳到Index页面，而是刷新当前页面

      }
    },
    async resetForm() {

      //重置应该是重新获取用户信息填入表单
      const user = Utils.getCurrentUser() ?? {userName: ""}
      const response = await Apis.User.getUser(user.userName)

      if (response.data != null) {
        this.ruleForm.id = response.data.userID ?? -1
        this.ruleForm.username = response.data.username ?? ""
        this.ruleForm.phone = response.data.phone ?? ""
        this.ruleForm.email = response.data.email ?? ""
        this.ruleForm.wpsID = response.data.wpsID ?? ""

        this.ruleForm.pass = ""
        this.ruleForm.checkPass = ""
      }


    }
  },
  created() {
    this.resetForm()
  }
}
</script>

<style scoped>
h1 {
  text-align: center;
}

.main {
  display: flex;
  justify-content: center;
}


.register-btn {
  text-align: center;
}

</style>
